import * as THREE from "three"
import { useAnimatedTexture } from "@/hooks/use-animated-texture"
import { MinecraftColorProperties } from "@/types"
import { MinecraftTintableMaterial } from "./minecraft-tintable-material"

export default function FluidPlane({ fluidId, colorProps }: { fluidId: string,colorProps?: MinecraftColorProperties }) {
  const texturePath = fluidId.replace("minecraft:", "block/")
  const baseTex = useAnimatedTexture(`/textures/${texturePath}_still.png`)
  baseTex.magFilter = THREE.NearestFilter
  baseTex.minFilter = THREE.NearestFilter
  baseTex.wrapS = THREE.RepeatWrapping
  baseTex.wrapT = THREE.RepeatWrapping

  const colormapTex = useAnimatedTexture(
    colorProps?.colormap ? `/textures/colormap/${colorProps.colormap}.png` : "/placeholder.svg",
  )
  if (colorProps?.colormap) {
    colormapTex.magFilter = THREE.NearestFilter
    colormapTex.minFilter = THREE.NearestFilter
  }

  const material = new MinecraftTintableMaterial({
    baseTexture: baseTex,
    colormapTexture: colorProps?.colormap ? colormapTex : undefined,
    tintColor: colorProps?.baseTint, // This could be the biome-specific water color
    useColormap: !!colorProps?.colormap,
    useTintColor: !!colorProps?.baseTint,
  })

  return (
    <mesh rotation={[-Math.PI / 2, 0, 0]}>
      <planeGeometry args={[16, 16]} />
      <primitive object={material} attach="material" />
    </mesh>
  )
}
